import React, { useState, useEffect } from "react";
import { Link } from "react-router";
import { Dropdown } from "antd";

import { fetchAuthStatus } from "../ProtectedRoute/ProtectedRoute.jsx"; // Import the auth functions
import { genericDELETEDatabaseCall } from "../helperFunctions.jsx";

import {
  AppstoreOutlined,
  DownOutlined,
  DollarOutlined,
  BarChartOutlined,
  BuildOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import "./Navbar.css";

const productsDropdownMenu = {
  items: [
    {
      key: "fb",
      icon: <DollarOutlined style={{ fontSize: 22, color: "#c4a463" }} />,
      label: <Link to="/fb" style={{ fontSize: 16, fontWeight: 500 }}>Financial Builder</Link>,
    },
    {
      key: "cfi",
      icon: <BarChartOutlined style={{ fontSize: 22, color: "#5b8def" }} />,
      label: <Link to="/cfi" style={{ fontSize: 16, fontWeight: 500 }}>Critical Financial Insight</Link>,
    },
    {
      key: "psbb",
      icon: <BuildOutlined style={{ fontSize: 22, color: "#9b7bd4" }} />,
      label: <Link to="/psbb" style={{ fontSize: 16, fontWeight: 500 }}>Strategic Business Building</Link>,
    },
    {
      key: "dashboard",
      icon: <DashboardOutlined style={{ fontSize: 22, color: "#5fd0a0" }} />,
      label: <Link to="/dashboard" style={{ fontSize: 16, fontWeight: 500 }}>Dashboard</Link>,
    },
  ],
};

function ThemeToggle() {
  const [theme, setTheme] = useState(
    () => document.documentElement.getAttribute("data-theme") || "dark"
  );

  const toggle = () => {
    const next = theme === "dark" ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", next);
    localStorage.setItem("pn-theme", next);
    setTheme(next);
  };

  return (
    <button className="pn-theme-toggle" onClick={toggle} aria-label="Toggle theme">
      <svg className="pn-icon-moon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
      <svg className="pn-icon-sun" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="5" />
        <line x1="12" y1="1" x2="12" y2="3" />
        <line x1="12" y1="21" x2="12" y2="23" />
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
        <line x1="1" y1="12" x2="3" y2="12" />
        <line x1="21" y1="12" x2="23" y2="12" />
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
      </svg>
    </button>
  );
}

async function handleLogOut() {
  try {
    await genericDELETEDatabaseCall("/api/auth/logout", {}, "logout");
    window.location.reload();
  } catch (err) {
    console.log(err);
  }
}

function Navbar({ activeKey }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuthStatus = async () => {
      const status = await fetchAuthStatus();
      setIsAuthenticated(status);
    };
    checkAuthStatus();
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo">
          <img className="navbar-logo-img" src="/imgs/logo.png" alt="PreNumbers" />
          <span className="navbar-logo-text">PreNumbers</span>
        </Link>

        <div className="navbar-links">
          <Link to="/" className={`navbar-link ${activeKey === "home" ? "is-active" : ""}`}>
            Home
          </Link>
          <Link
            to="/solutions"
            className={`navbar-link ${activeKey === "solutions" ? "is-active" : ""}`}
          >
            Solutions
          </Link>
          <Link to="/pricing" className={`navbar-link ${activeKey === "pricing" ? "is-active" : ""}`}>
            Pricing
          </Link>
          <Link
            to="/contact-sales"
            className={`navbar-link ${activeKey === "contact" ? "is-active" : ""}`}
          >
            Contact
          </Link>
          {isAuthenticated && (
            <Dropdown
              menu={productsDropdownMenu}
              trigger={["hover"]}
              placement="bottom"
              overlayClassName="navbar-tooltip-dropdown"
            >
              <span className="navbar-link navbar-products">
                <AppstoreOutlined /> Products <DownOutlined className="navbar-products-caret" />
              </span>
            </Dropdown>
          )}
        </div>

        <div className="navbar-actions">
          <ThemeToggle />
          {isAuthenticated ? (
            <button onClick={handleLogOut} className="navbar-signin">
              Sign out
            </button>
          ) : (
            <Link to="/login" className="navbar-signin">
              Sign in
            </Link>
          )}
          <Link to="/contact-sales" className="navbar-demo-btn">
            Request a demo
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
